import { render, staticRenderFns } from "./YoutubeWindow.vue?vue&type=template&id=33ac5687&"
import script from "./YoutubeWindow.vue?vue&type=script&lang=js&"
export * from "./YoutubeWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports